import { Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledExpandableContent = styled.div<{
  expanded: boolean;
  isVerticalScrollable?: boolean;
}>`
  max-height: ${(props) => (props.expanded ? '600px' : '0')};
  overflow: ${(props) => (props.isVerticalScrollable ? 'auto' : 'hidden')};
  overflow-y: ${(props) => (props.isVerticalScrollable ? 'auto' : 'hidden')};
  transition: max-height 0.3s ease-in-out;
  height: ${(props) => (props.isVerticalScrollable ? 'auto' : 'auto')};
`;

export const StyledTypo = styled(Typography)`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
